'use client'

import clsx from 'clsx'
import { CaseStudy } from 'enums/CaseStudy.enum'
import { useInView } from 'motion/react'
import { useEffect, useRef } from 'react'
import styles from './Quote.module.scss'

export type QuoteProps = {
  caseStudy: CaseStudy
  contentText: string
  creditName: string
  creditCompany: string
}

const Quote = ({ caseStudy, contentText, creditName, creditCompany }: QuoteProps) => {
  const targetRef = useRef<HTMLParagraphElement>(null)
  const inView = useInView(targetRef, { amount: 0.5 })

  useEffect(() => {
    if (inView) {
      targetRef.current?.classList.add(styles['in-view'])
    } else {
      targetRef.current?.classList.remove(styles['in-view'])
    }
  }, [inView])

  return (
    <section className={clsx(styles['quote-container'], styles[caseStudy])}>
      <p className={clsx(styles.quote, styles[caseStudy])}>{contentText}</p>
      <div className={clsx(styles.credit, styles[caseStudy])}>
        <span>{creditName}</span>
        <span>{creditCompany}</span>
      </div>
    </section>
  )
}

export default Quote
